/**
 * Conversion events for Google Tag Manager (container GTM-PSBF8WLZ).
 *
 * GTM reads these from window.dataLayer; GA4 event tags and key events are
 * configured inside the container (see docs/gtm-ga4-setup.md). Consent is
 * applied by GTM itself through Google Consent Mode (index.html), and in
 * opt-in regions GTM isn't even loaded until the visitor accepts — so pushing
 * here is always safe. Never put personal data (names, emails, phone numbers
 * typed by the visitor, messages) in an event.
 *
 * Events:
 *   generate_lead  — a contact / lead form was accepted by the server
 *   quote_request  — a quote (order) request was accepted by the server
 *   phone_tap      — a tel: link was tapped (not a completed call)
 *   email_tap      — a mailto: link was tapped
 */
type Params = Record<string, string | number | boolean | null>;
type DlWindow = Window & { dataLayer?: unknown[] };

export function pushDataLayer(event: string, params: Params = {}) {
  try {
    if (typeof window === "undefined") return;
    const w = window as DlWindow;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event, page_path: location.pathname, ...params });
  } catch { /* measurement must never break the page */ }
}

let listening = false;

/** One delegated listener for phone / email taps. Mount once (useAnalytics). */
export function initDataLayerListeners() {
  if (listening || typeof document === "undefined") return;
  listening = true;
  document.addEventListener("click", (e) => {
    try {
      const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      const href = a?.getAttribute("href") || "";
      if (href.startsWith("tel:")) pushDataLayer("phone_tap", { link_url: href });
      else if (href.startsWith("mailto:")) pushDataLayer("email_tap", {});
    } catch { /* best-effort */ }
  }, { capture: true });
}
